import { IpfError } from '@ipfabric/frontend-shared-assets/utils/IpfError';
import {
  type EdgeData,
  type EdgeId,
  type NodeSn,
  type SnapshotId,
  isPathLookupEdgeData,
  isTopologyEdgeData,
} from '@ipfabric/utils';
import type { GraphData } from 'components/Graph/model/GraphData';
import type { ShowEdgeDetailCommand } from '../model/commands/showEdgeDetail';
import { getDeviceExplorerEdgeData } from './getDeviceExplorerEdgeData';
import { getDeviceViewEntityEdgeId } from './getDeviceViewEntityEdgeId';

const getEdgeType = (edgeData: EdgeData): 'topology' | 'pathLookup' => {
  if (isTopologyEdgeData(edgeData)) {
    return 'topology';
  }
  if (isPathLookupEdgeData(edgeData)) {
    return 'pathLookup';
  }
  throw new IpfError('INVALID_ARGUMENT', 'Unknown edge type');
};

export const getShowEdgeDetailArgs = (
  id: EdgeId,
  edgeData: EdgeData,
  graphData: GraphData,
  sourceSn: NodeSn | null,
  targetSn: NodeSn | null,
  snapshotToCompareId: SnapshotId | null,
): ShowEdgeDetailCommand => ({
  entity: {
    deviceViewElement: 'edge',
    edgeId: id,
    id: getDeviceViewEntityEdgeId(id),
    loaded: false,
    tableSort: {},
    table: null,
    tableFilters: {},
    type: getEdgeType(edgeData),
    ...getDeviceExplorerEdgeData(
      edgeData,
      graphData,
      sourceSn,
      targetSn,
      snapshotToCompareId,
    ),
  },
});
